module.exports = __webpack_public_path__ + "img/05.e526a8c5.jpg";